var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "novel-book-root" }, [
    _c(
      "div",
      { staticClass: "image-area" },
      [
        _c(
          "router-link",
          {
            staticClass: "novel-book",
            class: { "tutorial-novel": _vm.novel.title === "はじめてのNola" },
            attrs: {
              to: { name: "editor", params: { novelId: _vm.novel.novelId } },
            },
          },
          [
            _c("image-view", {
              key: _vm.coverImageVersion,
              staticClass: "novel-image",
              attrs: {
                src: _vm.getImageKey,
                placeholder: "/img/placeholders/novel.png",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pinned", on: { click: _vm.onClickPinned } },
          [
            _c("IconPin", {
              staticClass: "pin-icon",
              class: { active: _vm.novel.pinned },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "dots-wrapper" }, [
          _c(
            "button",
            { staticClass: "dots-container", on: { click: _vm.toggleMenu } },
            [_c("IconVerticalEllipsis", { staticClass: "icon-18" })],
            1
          ),
          _vm.isMenuOpen
            ? _c("div", { staticClass: "menu-popover" }, [
                _c(
                  "button",
                  {
                    staticClass: "menu-item",
                    on: { click: _vm.showCopyNovelDialog },
                  },
                  [
                    _c("IconCopy", { staticClass: "menu-item-icon" }),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("homePage.novelList.listItem.copyNovel"))
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "menu-item",
                    on: { click: _vm.showGroupingDialog },
                  },
                  [
                    _c("IconFolderHeart", { staticClass: "menu-item-icon" }),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("homePage.novelList.listItem.grouping"))
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  { staticClass: "menu-item", on: { click: _vm.importNovel } },
                  [
                    _c("IconUpload", { staticClass: "menu-item-icon" }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("homePage.novelList.listItem.importManuscript")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "menu-item menu-item-danger",
                    on: { click: _vm.deleteNovel },
                  },
                  [
                    _c("IconTrash", { staticClass: "menu-item-icon" }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("homePage.novelList.listItem.deleteNovel")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _c("input", {
          ref: "input",
          staticStyle: { display: "none" },
          attrs: { type: "file", accept: ".txt,.docx", multiple: "" },
          on: {
            change: function ($event) {
              return _vm.onSelectFile()
            },
          },
        }),
      ],
      1
    ),
    _vm.isMenuOpen
      ? _c("div", {
          staticClass: "menu-backdrop",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggleMenu.apply(null, arguments)
            },
          },
        })
      : _vm._e(),
    _c(
      "div",
      { staticClass: "novel-meta" },
      [
        _c(
          "router-link",
          {
            staticClass: "novel-title-link",
            attrs: {
              to: { name: "editor", params: { novelId: _vm.novel.novelId } },
            },
          },
          [
            _c("div", { staticClass: "novel-title line-clamp" }, [
              _vm._v(_vm._s(_vm.novel.title)),
            ]),
          ]
        ),
        _c("div", { staticClass: "novel-info-row" }, [
          _c("div", { staticClass: "novel-dates" }, [
            _c(
              "span",
              { staticClass: "novel-date" },
              [
                _c("IconReload", { staticClass: "date-icon" }),
                _vm._v(" " + _vm._s(_vm.toUpdatedAt) + " "),
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "novel-date" },
              [
                _c("IconPencil", { staticClass: "date-icon" }),
                _vm._v(" " + _vm._s(_vm.toCreatedAt) + " "),
              ],
              1
            ),
          ]),
          _vm.workStatusLabel
            ? _c("span", { staticClass: "novel-status-badge" }, [
                _vm._v(_vm._s(_vm.workStatusLabel)),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }